import { CUSTOM_FIELD_TYPES } from 'constants/custom-fields';
import { CURRENCY_SYMBOLS } from 'constants/index';

import CustomFieldContainer from 'containers/CustomFieldContainer';

import { CustomFieldType, CurrencySymbol } from 'types';

interface IconProps {
    type?: CustomFieldType,
    useCurrencySymbol?: boolean,
    currency?: CurrencySymbol,
    onlyIfType?: CustomFieldType
}

const Icon = ({ type, useCurrencySymbol, currency, onlyIfType }: IconProps) => {
    if (onlyIfType && type !== onlyIfType) {
        return null;
    }

    if (useCurrencySymbol && currency && type && ['budget', 'currency'].includes(type)) {
        return <span className="currency-symbol">{ CURRENCY_SYMBOLS[currency] }</span>;
    }

    const customFieldType = CUSTOM_FIELD_TYPES.find(field => field.id === type);

    if (!customFieldType?.fieldIcon) {
        return null;
    }

    return customFieldType.fieldIcon;
};

interface CustomFieldIconProps {
    id?: string,
    type?: CustomFieldType,
    useCurrencySymbol?: boolean,
    onlyIfType?: CustomFieldType
}

const CustomFieldIcon = ({ id, type, useCurrencySymbol, onlyIfType }: CustomFieldIconProps) => {
    if (id) {
        return <CustomFieldContainer id={id}><Icon useCurrencySymbol={useCurrencySymbol} onlyIfType={onlyIfType} /></CustomFieldContainer>;
    }

    return <Icon type={type} />;
}

export default CustomFieldIcon;
